import { render, staticRenderFns } from "./BannerBienvenidaOferta.vue?vue&type=template&id=bb62511e&scoped=true"
import script from "./BannerBienvenidaOferta.vue?vue&type=script&lang=js"
export * from "./BannerBienvenidaOferta.vue?vue&type=script&lang=js"
import style0 from "./BannerBienvenidaOferta.vue?vue&type=style&index=0&id=bb62511e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb62511e",
  null
  
)

export default component.exports